@if (appStatus(); as appStatus) {
  <div class="site">
    <ng-container>
      <!--toolbar - universal app toolbar -->
      <app-navbar (menuToggle)="toggle()" [showMenuButton]="showSidebar()"></app-navbar>
      <mat-divider></mat-divider>
      <!--side menu + content-->
      <mat-sidenav-container [style.marginTop.px]="56" [hasBackdrop]="showSidebar() && isMobile()">
        @if (showSidebar()) {
          <mat-sidenav [mode]="isMobile() ? 'over' : 'side'" [fixedInViewport]="isMobile()"
            [opened]="!isMobile()" fixedTopGap="56" fixedBottomGap (click)="navigationClick()">
            <app-sidenav-content></app-sidenav-content>
          </mat-sidenav>
        }
        <mat-sidenav-content>
          <!-- main content -->
          <router-outlet></router-outlet>
          <app-footer></app-footer>
        </mat-sidenav-content>
      </mat-sidenav-container>
    </ng-container>
  </div>
}
